import { useEffect, useCallback } from 'react';
import { useStateSelector, useCooperativeId } from 'hooks';
import { useDispatch } from 'react-redux';
import { CaseBaseModel } from 'models';
import {
  fetchWidgets,
  setShowWelcomeWidget,
  modifyBaseCase,
} from 'store/widgets/slicer';

import { MainPageDetails } from 'components';

const MainPage = () => {
  const dispatch = useDispatch();
  const coopId = useCooperativeId();
  const {
    userSettings,
    showWelcomeWidget,
    currentPortal,
    loading,
    error,
    userWidgets,
  } = useStateSelector((state) => ({
    userWidgets: state.widgets.userWidgets,
    loading: state.widgets.loading,
    error: state.widgets.error,
    currentPortal: state.settings.current_portal,
    showWelcomeWidget: state.widgets.showWelcomeWidget,
    userSettings: state.app.userSettings,
  }));

  useEffect(() => {
    if (coopId) {
      const url =
        currentPortal?.Name === 'Default'
          ? `/api/user/cooperatives/${coopId}/overview`
          : currentPortal?.Name === 'Maintenance'
          ? `/api/user/maintenance/cooperatives/${coopId}/overview`
          : null;

      if (url) {
        dispatch(fetchWidgets(url));
      }
    }
  }, [coopId]);

  const handleChangeBaseCase = useCallback((newBaseCase: CaseBaseModel) => {
    dispatch(modifyBaseCase(newBaseCase));
  }, []);

  const initWelcomeWidget = useCallback(() => {
    dispatch(setShowWelcomeWidget(false));
  }, [dispatch]);

  return (
    <MainPageDetails
      error={error}
      loading={loading}
      userWidgets={userWidgets}
      showWelcomeWidget={showWelcomeWidget}
      initWelcomeWidget={initWelcomeWidget}
      userSettings={userSettings}
      handleChangeBaseCase={handleChangeBaseCase}
    />
  );
};

export default MainPage;
